







































import Vue, { PropType } from 'vue'

import { MutationTypes } from '@/store/admin/Map/types'
import { Mutations } from '@/store/admin/Map/mutations'
import { State } from '@/store/admin/Map/state'
import { Marker } from '@/components/Map/types'

export default Vue.extend({
  name: 'SearchBar',
  props: {
    markers: Array as PropType<Marker[]>,
    reset: Boolean
  },
  data: () => ({
    query: '',
    selected: null,
    typingTimeout: null
  }),
  computed: {
    filtered (): Marker[] { return this.$refs.selection.filteredItems }
  },
  methods: {
    filter (item: Record<string, any>, query: string): boolean {
      const properties = ['name', 'imei', 'short_name', 'sub_vendor_name']

      return properties
        .map((p: string) => String(item[p] || '').toLowerCase())
        .some((s: string) => s.includes(query?.toLowerCase()))
    },
    emitOnMarker (v: string | any): Mutations<State> | void {
      if (v && typeof v !== 'string') {
        this.$emit('found', v)
        this.$store.commit(`Map/${MutationTypes.SET_SEARCH_BOUNDING}`, false)
      }
    }
  },
  watch: {
    query (value: string): Mutations<State> | void {
      clearTimeout(this.typingTimeout)

      if (this.filtered) {
        const valid = value?.length > 2
        const isSelected = this.selected?.name === value || false
        const items = valid ? this.filtered : this.markers
        this.typingTimeout = setTimeout(() => {
          if (items && !isSelected) {
            this.$store.commit(`Map/${MutationTypes.SET_SEARCH_BOUNDING}`, valid && this.filtered.length !== 0)
            this.$emit('updated-search-criteria', items)
          }
        }, 500)
      }
    },
    reset (b: boolean) { if (b) this.query = '' }
  }
})
